import { CaretRight, EnvelopeOpen } from '@phosphor-icons/react';
import Avatar from '../../../../../shared/components/Avatar';
import Empty from '../../../../../shared/components/Empty';
import { Envelope } from '@phosphor-icons/react';
import { formatDate } from '../../../../../shared/utils/date';

type InquiriesListProps = {
  inquiries: any[];
  t: any;
  onSelect: (inquiryId: string) => void;
};

export default function InquiriesList({ inquiries, t, onSelect }: InquiriesListProps) {
  if (!inquiries.length) return <Empty icon={Envelope} title={t.noInquiries} />;

  return (
    <div className="inquiries-list">
      {inquiries.map((inquiry) => (
        <button key={inquiry.id} onClick={() => onSelect(inquiry.id)}>
          <span className="inquiry-mail"><EnvelopeOpen /></span>
          <Avatar
            user={{
              username: inquiry.senderUsername,
              avatar: inquiry.senderAvatar,
              color: inquiry.senderColor,
            }}
            size={42}
          />
          <span>
            <b>{inquiry.subject}</b>
            <small>@{inquiry.senderUsername} · {inquiry.placeName}</small>
          </span>
          <time>{formatDate(inquiry.createdAt, t.locale)}</time>
          <CaretRight />
        </button>
      ))}
    </div>
  );
}
